export const ur_UR = {
    "PREFIX": {
        "QUESTION": "سوال",
        "QUESTION-PART": "سوال",
        "PRE-RELEASE": "پری ریلیز",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "نمبرز"
    }
};

